export const API_EXTERNAL_ENDPOINT = 'cottages/:id/recommended/cottage-contact'
export const API_INTERNAL_ENDPOINT = `rurality/v2/cottages/recommended`
